import { Observations } from "../../../../common/components/ui/observations/Observations";
import { AuthContext } from "../../../../common/components/auth/authContext/AuthContext";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { createObservations } from "../../../../common/services/observations.api";
import { useVehicleDashboardContext } from "./useVehicleDashboardContext";
import { useContext } from "react";

export function VehicleObservations() {
  const { vehicle } = useVehicleDashboardContext();
    const { notifySuccess, notifyError } = useToastContext();


  const authCtx = useContext(AuthContext);
  const userEmail = authCtx.auth?.user?.email;

  const handleAddObservation = async (newObservation) => {

    const entityType = "vehicles"

    const result = await createObservations(vehicle._id, newObservation, entityType);

    if(result.ok){
      notifySuccess("Observação salva com sucesso!")
    }else{
        notifyError(result.message as string)
    }

  };

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">
        <div className="justify-between flex items-center w-full border-b border-gray/40 pb-2 mb-4">
          <h2 className="font-semibold text-2xl mb-4">Observações</h2>
        </div>
        <Observations
          initialObservations={vehicle?.observations || []}
          author={userEmail || ""}
          onAddObservation={handleAddObservation}
          entityId={vehicle._id}
          entityType="vehicles"
        />

      </section>
    </div>
  );
}
